export var ABTEST = 'ABTest';
export var USER_DATA_PLATFORM = 'UserDataPlatform';
export var FAQ_SEARCH = 'FAQSearch';
export var MARKETPLACE = 'Marketplace';
export var WORDPRESS = 'WordPress';
export var WORDPRESS_SEARCH = 'WordPressSearch';
export var WORDPRESS_TABLES = 'WordPressTables';